import React from 'react'

 const About = () => {
  return (
    <div>
      <h6>An App About Adding Your Favorites Actors.</h6>
      <p>Version 1.5</p>
    </div>
  )
}

export default About;
